import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BE_API_AUTH_URL } from '../constants/app.constants';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SupportService {
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  createSupportRequest(payload: any): Observable<{ message: string; id: string }> {
    return this.http
      .post<{ message: string; id: string }>(
        `${BE_API_AUTH_URL}/support/request`,
        payload,
        { headers: this.authService.createAuthorizationHeader() }
      )
      .pipe(catchError(this.authService.handleError.bind(this.authService)));
  }
}
